<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item
        >
          <div class="div1">系统管理</div>
        </el-breadcrumb-item
        >
        <el-breadcrumb-item
        >
          <div class="div2">域名过期监控</div>
        </el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 teamManage -->
    <!-- 添加团队 -->
    <div class="content">
      <h2>域名过期监控</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" id="search" size="small">
          <el-form-item label="域名">
            <el-input
                v-model="search.domainName"
                placeholder="请输入域名"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="账号">
            <el-input
                v-model="search.username"
                placeholder="请输入账号"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="服务商">
            <el-input
                v-model="search.providerName"
                placeholder="请输入服务商"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
            >查询
            </el-button
            >
            <el-button
                type="primary"
                plain
                @click="fetchData('reset')"
            >重置
            </el-button
            >
          </el-form-item
          >
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3 class="data-list-title">
        数据列表
        <el-button size="small" type="button" @click="refreshAll()">刷新所有域名</el-button>
        <el-button size="small" type="button" @click="showConfigs()">域名账号管理</el-button>
      </h3>
      <lb-table
          :column="column"
          :data="domainList"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
          @sort-change="handleSortChange"
      >
      </lb-table>
    </div>

    <el-dialog
        title="域名账号管理"
        :visible.sync="configs.daDialogVisible"
        width="70%"
        :append-to-body="true"
        class="company-dialog">
      <div class="content">
        <el-form :inline="true" id="search" size="small">
          <el-form-item label="服务商名称">
            <el-input
                v-model="configs.search.providerName"
                placeholder="请输入服务商名称"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="账号">
            <el-input
                v-model="configs.search.username"
                placeholder="请输入账号"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchConfigsData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchConfigsData('reset')">重置</el-button>
            <el-button type="primary" @click="toAddOrEditConfig()">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
          width="100%"
          :data="configs.accountList">
        <el-table-column
            width="100"
            label="序号">
          <template slot-scope="scope">
            {{ (configs.page.pageNo - 1) * configs.page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
            prop="providerName"
            label="服务商名称">
        </el-table-column>
        <el-table-column
            prop="username"
            label="账号">
        </el-table-column>
        <el-table-column
            prop="secretId"
            label="密钥Id/账号">
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" plain @click="toAddOrEditConfig(scope.row)">修改</el-button>
            <el-button type="text" plain @click="removeConfigsById(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleConfigsSizeChange"
          @current-change="handleConfigsCurrentChange"
          :current-page="configs.page.pageNo"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="configs.page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="configs.page.totalNum"
          prev-text="上一页"
          next-text="下一页"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="configs.daDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :title="configs.dialogTitle"
        :visible.sync="configs.addDialogVisible"
        width="30%"
        :append-to-body="true"
        class="company-dialog">
      <div class="content">
        <el-form :model="configs.form" ref="form" label-width="100px">
          <el-form-item label="服务商" prop="providerName" required>
            <el-select v-model="configs.form.providerName" placeholder="请选择服务商">
              <el-option v-for="item in configs.providerList" :value="item.value" :label="item.label"
                         :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账号" prop="username" required>
            <el-input v-model="configs.form.username" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密钥Id/账号" prop="secretId" required>
            <el-input v-model="configs.form.secretId" placeholder="请输入密钥Id/账号"></el-input>
          </el-form-item>
          <el-form-item label="秘钥">
            <el-input type="textarea" v-model="configs.form.secretKey"
                      placeholder="为安全考虑，不进行显示，设置后不显示，请注意保存"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitConfigsForm('form')">确 定</el-button>
        <el-button @click="configs.addDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { FormItem } from 'element-ui';
import LbTable from '../../../components/lb-table/lb-table'
import {checkSort} from '@/utils/rules.js';

export default {
  name: 'role',
  components: {LbTable},
  data() {
    return {
      configs: {
        daDialogVisible: false,
        accountList: [],
        search: {
          providerName: '',
          username: ''
        },
        page: {
          pageNo: 1,
          pageSize: 10
        },
        dialogTitle: '新增',
        dialogType: 'add',
        addDialogVisible: false,
        form: {
          providerName: '',
          username: '',
          secretId: '',
          secretKey: ''
        },
        providerList: [
          {
            label: '阿里云',
            value: '阿里云'
          },
          {
            label: '西部数码',
            value: '西部数码'
          }
        ]
      },
      search: {},
      searchOrder: {orderField: '', orderType: ''},
      domainList: [], // 公司列表
      column: [
        {
          label: '序号',
          render: (h, scope) => {
            return (<div>{(this.page.pageNo - 1) * this.page.pageSize + scope.$index + 1}</div>)
          }
        },
        {label: '域名', prop: 'domain'},
        {
          label: '状态',
          render: (h, scope) => {
            if (0 === scope.row.status) {
              return (
                  <div>
                    正常
                  </div>
              )
            }
            return (
                <div>
                  已过期
                </div>
            )
          }
        },
        {label: '服务商', prop: 'providerName'},
        {label: '账号', prop: 'username'},
        {label: '过期时间', prop: 'expirationDate', sortable: true},
        {label: '备注', prop: 'remark'},
        {label: '创建时间', prop: 'createdTime', sortable: true},
        {label: '最后更新时间', prop: 'updatedTime'}
      ],
      page: {pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1},
      dialog: {visible: false, title: "编辑", type: ''},
      form: {
        domain: '' // 域名 string
      },
      rules: {
        name: [
          {required: true, message: '请输入公司名称', trigger: 'blur'},
          {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
        ]
      },
      dictionaries: { // 字典数据
        domain_status: [] // 状态
      },
      brandList: [], // 品牌管理列表数据
      parArray: [] // 按钮权限
    };
  },
  created() {
    this.fetchData()
    // 获取字典值
    for (let type in this.dictionaries) {
      this.getDictionaries(type)
    }
  },
  /*
  watch: {
    permissionFilterText (val) {
      this.$refs.tree.filter(val);
    }
  },
  */
  methods: {
    fetchData(type) {
      if (type == 'reset') {
        this.search = {}
        this.page.pageNo = 1
        this.page.pageSize = 10
        this.page.currentPage = 1
      }
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      if (type == 'search') {
        this.page.currentPage = 1
        this.page.pageNo = 1
        params.pageNo = 1
        params = Object.assign(params, this.search);
        // 去除字符串 前后 空格
        for (let item in params) {
          if (typeof params[item] === "string") {
            params[item] = params[item].trim()
          }
        }
      }
      params.orderField = this.searchOrder.orderField
      params.orderType = this.searchOrder.orderType
      this.axios
          .post('/basic/domainList/getPageList', params)
          .then((res) => {
            this.domainList = res.data.list
            this.page.totalNum = res.data.totalNum
          }).catch((err) => {
        console.log(err)
      })
    },
    handleSortChange(e) {
      this.searchOrder.orderField = e.prop
      this.searchOrder.orderType = e.order
      this.fetchData()
    },
    handleCurrentChange(currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) {
        return
      }
      const params = {groupId: type}
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 显示  dialog
    showDialog(title, type, row) {
      this.dialog.type = type
      this.currentRow = row
      this.dialog.visible = true;
      this.dialog.title = '新增';
      this.form = {
        domain: '' // 域名 string
      }
      this.$refs["form"].resetFields();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    // 刷新所有
    refreshAll() {
      this.$confirm('是否刷新所有域名信息', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.axios
            .get('/basic/domainList/refresh')
            .then((res) => {
              if (res.code == 0) {
                this.fetchData()
                this.$message({
                  type: 'success',
                  message: '刷新成功!'
                });
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        // 取消
      });
    },
    // 刷新所有
    showConfigs() {
      this.fetchConfigsData('reset')
      this.configs.daDialogVisible = true
    },
    toAddOrEditConfig(row) {
      if (row && row.id) {
        this.showConfigDialog('编辑', 'edit', row)
      } else {
        this.showConfigDialog('新增', 'add')
      }
    },
    showConfigDialog(title, type, row) {
      this.configs.dialogType = type
      this.configs.dialogTitle = title
      if (type === 'edit') {
        this.configs.form = {
          id: row.id,
          providerName: row.providerName,
          username: row.username,
          secretId: row.secretId,
        }
      } else {
        this.configs.form = {
          id: null,
          providerName: '',
          username: '',
          secretId: ''
        }
      }
      this.configs.addDialogVisible = true
    },
    fetchConfigsData(type) {
      if (type == 'reset') {
        this.configs.search = {}
        this.configs.page.pageNo = 1
        this.configs.page.pageSize = 10
        this.configs.page.currentPage = 1
      }
      let params = {
        pageNo: this.configs.page.pageNo,
        pageSize: this.configs.page.pageSize
      }
      if (type == 'search') {
        this.configs.page.currentPage = 1
        this.configs.page.pageNo = 1
        params.pageNo = 1
        params = Object.assign(params, this.configs.search);
        // 去除字符串 前后 空格
        for (let item in params) {
          if (typeof params[item] === "string") {
            params[item] = params[item].trim()
          }
        }
      }
      this.axios
          .post('/basic/domainList/getConfigPageList', params)
          .then((res) => {
            this.configs.accountList = res.data.list
            this.configs.page.totalNum = res.data.totalNum
          }).catch((err) => {
        console.log(err)
      })
    },
    handleConfigsCurrentChange(currentChange) {
      this.configs.page.pageNo = currentChange
      this.fetchConfigsData()
    },
    handleConfigsSizeChange(sizeChange) {
      this.configs.page.pageSize = sizeChange
      this.fetchConfigsData()
    },
    removeConfigsById(id) {
      this.$confirm('是否删除该账号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {id}
        this.axios
            .post('/basic/domainList/removeConfig', params)
            .then((res) => {
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                this.fetchConfigsData()
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
          console.log(err)
        })
      }).catch(_ => {
        // 取消
      });
    },
    submitConfigsForm() {
      this.axios
          .post('/basic/domainList/saveConfig', this.configs.form)
          .then((res) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.configs.addDialogVisible = false
              this.fetchConfigsData()
            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.div3 {
  margin-left: -8px;
  background: url(../../../assets/breadcrumb3.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

//
//#search{
//  display: flex;
//  .el-form-item{
//    flex: 1;
//    .el-form-item__content{
//      width: 80%;
//    }
//  }
//}

.content {
  .el-button {
    margin-bottom: 10px;
  }

  .el-badge {
    margin-left: 10px;
  }
}

.roleList {
  border: 1px solid #f0f3fd;
  border-radius: 5px;

  .title {
    color: #333333;
    line-height: 40px;
    padding: 0 10px;
    background-color: #f0f3fd;

    .el-badge {
      margin-top: 10px;
      margin-left: 10px;
    }
  }

  .list {
    padding: 20px;

    .el-tag {
      border: 0;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}

.dialog-content {
  // min-height: 210px;
  .el-tree {
    max-height: 300px;
    overflow: auto;
  }

  .el-radio {
    // display: block;
    // margin: 8px 0;
  }
}
</style>
<style lang="scss">
.content {
  .el-link {
    margin: 0 5px;
  }

  h4 {
    padding-top: 10px;
    border-top: 1px solid #bbbbbb;
  }
}
</style>
